import { render, staticRenderFns } from "./FormOrder.vue?vue&type=template&id=a8267016&scoped=true"
import script from "./FormOrder.vue?vue&type=script&lang=js"
export * from "./FormOrder.vue?vue&type=script&lang=js"
import style0 from "./FormOrder.vue?vue&type=style&index=0&id=a8267016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8267016",
  null
  
)

export default component.exports